module.exports = __webpack_public_path__ + "media/images/favicon-e2e4355e.ico";